export default "__VITE_ASSET__B3x5YYBM__"